var canvas = document.createElement('canvas')
var gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl')
let hasWebgl =
  gl && (gl instanceof window.WebGLRenderingContext || gl instanceof window.WebGL2RenderingContext)
export default hasWebgl
